import type { ProjectSortOptions } from '@/api/v4/projects.api';
import type { HeaderCellConfig } from '@/ui/table/table.types';
import { colors } from '@/theme/colors';

export const projectsHeaders: HeaderCellConfig<ProjectSortOptions>[] = [
  {
    columnKey: 'project',
    width: '14%',
    sortKey: 'projectName',
    defaultSortDirection: 'asc',
    bgColor: colors.gray.c1,
  },
  {
    columnKey: 'type',
    width: '13%',
    bgColor: colors.gray.c1,
  },
  {
    columnKey: 'stage',
    width: '13%',
    sortKey: 'stage',
    bgColor: colors.gray.c1,
  },
  {
    columnKey: 'tags',
    width: '19%',
    minWidth: { xl: '20em', lg: '14em' },
    bgColor: colors.gray.c1,
  },
  {
    columnKey: 'createdFor',
    width: '8%',
    sortKey: 'createdFor',
    defaultSortDirection: 'asc',
    bgColor: colors.gray.c1,
  },
  {
    columnKey: 'status',
    width: '7%',
    bgColor: colors.gray.c1,
  },
  {
    columnKey: 'modified',
    width: '9%',
    sortKey: 'lastEditedDate',
    bgColor: colors.gray.c1,
  },
  {
    columnKey: 'owner',
    width: '7%',
    bgColor: colors.gray.c1,
  },
  {
    columnKey: '',
    width: '7%',
    bgColor: colors.gray.c1,
  },
];
